import type { OptionProp } from 'app/components/design-system-components/inputs/types'

export const getEntityFromOptionProp = (opt: OptionProp): any =>
  (Object.values(opt)[0] as OptionProp)?.option
